<template>
  <div class="enWarehouse">
    <!-- 入库清单 -->
    <div class="list_view">
      <div class="fixed"><span class="title">入库清单</span><span class="log_btn"  @click.stop="toLog">入库记录</span></div>
      <dl>
        <dd v-for="(item) in list" :key="item.boxNo">
          <div class="box"><p>箱格号：{{item.boxNo}}</p><p>箱格类型：{{item.boxType}}</p></div>
          <div class="trackNum"><p>入库单号：{{item.trackNum}}</p><span>{{item.wareHouse}}</span></div>
          <div class="date"><p>入库时间：{{item.date}}</p></div>
          <div class="check">
            <!-- <div class="checkbox-box">
              <div :class="['checkbox-inner',{'checkbox-check': checkNums}]"></div>
            </div> -->

            <input type="checkbox" v-bind:id="item.boxNo" v-bind:value="item.boxNo" v-model="checkNums">
            <label v-bind:for="item.boxNo">
              <div class="checkbox-inner"></div>
            </label>
          </div>
          <div class="cancel" @click.stop="cancelEn(item.boxNo,item.trackNum)"><p>取消入库</p></div>
        </dd>
      </dl>
      <div class="bot_view">
        <div class="l_btn_wrap">
          <span @click.stop="submitList">提交</span>
          <span @click.stop="checkAll">全选</span>
        </div>
        <div class="r_btn_wrap">
          <span @click.stop="toReturn">返回</span>
          <span @click.stop="toExit">退出登录</span>
        </div>
      </div>
    </div>
    <!-- 取消入库Dialog -->
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="closeOnClickModal">
      <span>入库单号：{{wareHouse.trackNum}}正在取消入库，已为你打开{{wareHouse.boxNo}}号箱格，请取走物品后随手关门</span>
    </el-dialog>
  </div>
</template>

<script>
var _this
import "../../../../static/CEsite/css/common.less"
import {showLoading, hideLoading} from "../../../../static/js/utils/utility"
export default {
  name: 'enWarehouseList',
  data() {
    return {
      actionType: '',
      dialogVisible: false,
      closeOnClickModal: true,
      wareHouse: {
        trackNum: '10086', // 取消入库的单号（由后台或者硬件告知）
        boxNo: '1', // 取消入库的单号所处的空闲箱格号（由后台或者硬件告知）
      },
      list: [
        {
          boxNo: '1',
          boxType: '大',
          trackNum: '1000000000000086',
          wareHouse: '未入库',
          date: '2019-01-01 12:00:00'
        }, {
          boxNo: '2',
          boxType: '大',
          trackNum: '10087',
          wareHouse: '未入库',
          date: '2019-01-02 12:00:00'
        }, {
          boxNo: '3',
          boxType: '大',
          trackNum: '10088',
          wareHouse: '未入库',
          date: '2019-01-03 12:00:00'
        }, {
          boxNo: '4',
          boxType: '大',
          trackNum: '10089',
          wareHouse: '未入库',
          date: '2019-01-04 12:00:00'
        }, {
          boxNo: '5',
          boxType: '大',
          trackNum: '10090',
          wareHouse: '未入库',
          date: '2019-01-05 12:00:00'
        }, {
          boxNo: '6',
          boxType: '大',
          trackNum: '10091',
          wareHouse: '未入库',
          date: '2019-01-06 12:00:00'
        }, {
          boxNo: '7',
          boxType: '大',
          trackNum: '10092',
          wareHouse: '未入库',
          date: '2019-01-07 12:00:00'
        }, {
          boxNo: '8',
          boxType: '大',
          trackNum: '10093',
          wareHouse: '未入库',
          date: '2019-01-08 12:00:00'
        }, {
          boxNo: '9',
          boxType: '大',
          trackNum: '10094',
          wareHouse: '未入库',
          date: '2019-01-09 12:00:00'
        }, {
          boxNo: '10',
          boxType: '大',
          trackNum: '10095',
          wareHouse: '未入库',
          date: '2019-01-10 12:00:00'
        }, {
          boxNo: '11',
          boxType: '小',
          trackNum: '10096',
          wareHouse: '未入库',
          date: '2019-01-10 12:00:00'
        }
      ],
      checkNums: ["2"],
    }
  },
  created() { // 发起请求，获取入库清单
    showLoading();
    this.actionType = this.$route.query.actionType;
    console.warn('清单页actionType：',this.actionType);
  },
  mounted() {
    _this = this;
    setTimeout(() => {
      hideLoading()
    }, 1000*1);
  },
  methods: {
    // 展示入库记录
    toLog() {
      _this.$router.push({
        path: '/eSite/enWarehouse/enWarehouseLog',
        query: {actionType: _this.actionType}
      })
    },
    // 提交清单
    submitList() {
      console.log('提交清单,checkNums:',_this.checkNums);
    },
    // 全选
    checkAll() {
      console.log('全选checkAll:',_this.checkNums.length, _this.list.length);
      if (_this.checkNums.length >= _this.list.length) { // 反选
        _this.checkNums = [];
        return;
      }
      for(let i = 0; i< _this.list.length; i++) { // 全选
        // arr.push(that.list[i].boxNo); 
        _this.checkNums.push(_this.list[i].boxNo);
      }
      let checkNums = [...new Set(_this.checkNums)]; // Set去重，并且使用扩展运算符使Set对象变成数组
      console.log('checkNums:', checkNums);
    },
    // 取消入库,打开箱格之后，应该重新发起请求，刷新入库清单表
    cancelEn(boxNo,trackNum) {
      console.log('取消入库',boxNo,trackNum);
      _this.dialogVisible = false;
      // _this.wareHouse['boxNo'] = boxNo;
      // _this.wareHouse['trackNum'] = trackNum;
      _this.wareHouse = {..._this.wareHouse, boxNo, trackNum}
      console.log(_this.wareHouse);
      _this.dialogVisible = true;
    },
    // 返回上一页
    toReturn() {
      let that = this;
      that.$router.go(-1);
    },
    // 退出登录,需要清除token
    toExit() {
      let that = this;
      that.$router.push({
        path: '/',
      })
    },
  } 
}
</script>

<style lang="less">
.enWarehouse{
.list_view {
  width: 70%;
  overflow: hidden;
  padding: 0.87rem 0 0 0; 
  position: relative;
  background-color: rgba(255, 255, 255, 1);
  // border: 1px solid #333;
  border: 1px solid rgba(121, 121, 121, 1);
  border-radius: 0.08rem 0.08rem 0 0;
  .fixed {
    width: 100%;
    position: absolute;
    top: 0.01rem;
    // left: 0.01rem;
    text-align: center;
    padding: 0.1rem;
    background-color: rgba(255, 255, 255, 1);
    display: flex;
    .title {
      flex: 7;
      color: #333;
    }
    .log_btn {
      flex: 1;
      font-size: 0.2rem;
      line-height: 0.6rem;
      border-radius: 0.04rem;
      background-color: #409EFF;
      border-color: #409EFF;
    }
  }
  dl {
    color: #333;
    height: 6.89rem;
    overflow: hidden;
    overflow-y: auto;
    min-height: 6.89rem;
    dd, dt {
      display: flex;
      padding: 0.1rem 0.3rem 0.15rem 0.1rem;
      // border: 1px solid #333;
    }
    dd {
      border-top: 1px solid rgba(121, 121, 121, 1);
      // border-bo: 1px solid #333;
      justify-content: space-between;
      div {
        // display: inline-block;
        height: 100%;
      }
      .trackNum {
        width: 3.1rem;
      }
      .date p,
      .box p:first-child,
      .trackNum p:first-child {
        font-weight: bold;
        margin-bottom: 0.1rem;
      }
      .trackNum span {
        color: #fff;
        font-size: 0.17rem;
        padding: 0.05rem 0.1rem;
        border-radius: 0.04rem;
        background-color: rgba(50, 155, 0, 1);
      }
      input[type='checkbox'] {
        display: none;
      }
      .checkbox-box {
        position: relative;
        width: 19px;
        height: 19px;
        border: solid 1px gray;
        border-radius: 4px;
      }
      label {
        display: inline-block;
        position: relative;
        width: 25px;
        height: 25px;
        border: solid 1px gray;
        border-radius: 4px;
        // background: #fff;
        // transition: all 0.5s;
      }
      .checkbox-inner {
        position: absolute;
        top: -5px;
        left: -1px;
        width: 30px;
        height: 17px;
        opacity: 0;
        transform: rotateZ(-50deg) scale(0.1);
        transition: transform .1s ease-out;
      }
      input[type='checkbox']:checked+label {
        div {
          border-width: 0 0 4px 4px;
          opacity: 1;
          border-style: solid;
          border-color: #58bc58;
          transform: rotateZ(-50deg) scale(1);
          &::after {
            content: "";
            position: absolute;
            left: -8px;
            top: -1px;
            opacity: 0;
            width: 25px;
            height: 25px;
            border-radius: 50%;
            background: rgba(100, 167, 255, 0.397);
            animation: ripple .2s ease-out;
          }
          @keyframes ripple {
            0% {
              opacity: 1;
              transform: scale(0.0);
            }
            100% {
              opacity: 1;
              transform: scale(1.8);
            }
          }
        }
      }
      .cancel {
        // align-items: center;
        p {
          padding: 0.115rem;
          font-size: 0.17rem;
          border: 1px solid #797979;
          border-radius: 0.04rem;
        }
      }
    }
  }
  .bot_view {
    color: #333;
    display: flex;
    padding: 0.15rem;
    justify-content: space-between;
    border-top: 1px solid #797979;
    span {
      color: #fff;
      padding: 0 0.3rem;
      display: inline-block;
      width: 1.65rem;
      height: 0.6rem;
      text-align: center;
      font-size: 0.2rem;
      line-height: 0.6rem;
      border-radius: 0.04rem;
      background-color: #409EFF;
      border-color: #409EFF;
    }
    span:nth-child(2) {
      margin-left: 0.2rem;
    }
  }
}
.el-dialog {
  // width: auto;
  top: 50%;
  margin-top: 0 !important;
  transform: translateY(-50%);
  // width: 53% !important;
  .el-dialog__header {
    display: none;
    // .el-dialog__headerbtn {
    //   // top: 0 !important;
    //   font-size: 0.5rem !important;
    //   top: 0.04rem;
    //   right: 0.15rem;
    // }
  }
  .el-dialog__body {
    font-size: 0.28rem;
    text-align: center;
    span {
      text-align: center;
    }
  }
}
}
</style>





// WEBPACK FOOTER //
// src/components/CEsite/EN-warehouse/enWarehouseList.vue